import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  IconRegularCheckmark,
  Input,
  Text,
  theme,
} from '@notino/react-styleguide';

import { wishlistMessages } from '@containers/WishList/components/messages';
import { styled } from '@linaria/react';

import messages from '../messages';

const Wrapper = styled.div`
  padding: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Copied = styled.div`
  color: ${theme.color.text.positive};
  ${theme.typography.labelRegular400}
  box-sizing: border-box;
  width: 100%;
  height: 1rem;
  margin: 1rem 0;
  display: inline-flex;
  svg {
    width: 18px;
    margin-right: 0.5rem;
  }
`;

export const Share = ({ sharedListUrl }: { sharedListUrl: string }) => {
  return (
    <Wrapper>
      <Text typography="labelRegular" marginBottom="1rem">
        <FormattedMessage {...messages.shareListDrawerText} />
      </Text>

      <Input value={sharedListUrl} readOnly={true} />

      <Copied>
        <IconRegularCheckmark color="icon.positive" />
        <FormattedMessage {...wishlistMessages.clipboard} />
      </Copied>
    </Wrapper>
  );
};
